import React from "react";
import BrokerSearch from "../Input/BrokerSearch";

const SelectBroker = ({formik, name, label, setSelectedBroker}) => {

    const {handleChange, errors, touched} = formik;

    return <div className={"sl-flex sl-flex-col sl-gap-2"}>
        <span
            className="sl-font sl-font-medium sl-text-sm sl-text-gray-700 "
        >{label}</span>
        <BrokerSearch
            hasError={touched[name] && !!errors[name]}
            isAdmin={true}
            onBrokerSelect={(broker) => {
                handleChange({
                    target: {name: name, value: broker.id}
                })
                setSelectedBroker(broker);
            }}/>
        {touched[name] &&
            <span
                className="sl-text-error-500 sl-font sl-text-sm sl-font">{errors[name]}</span>}
    </div>
};

export default SelectBroker;